import { useState, useEffect } from 'react';
import ProfileView from './components/ProfileView';
import LoadingScreen from './components/LoadingScreen';
import NotFound from './components/NotFound';
import './styles.css';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://admin.gotap.oo/api';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://admin.gotap.oo';

function App() {
  const [profile, setProfile] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const path = window.location.pathname.replace(/^\/+|\/+$/g, '');

  // Detect card_id/{uuid} vs {username}
  const isCardId = path.startsWith('card_id/');
  const identifier = isCardId ? path.replace('card_id/', '') : path;

  useEffect(() => {
    if (!identifier) {
      setError('no-username');
      setLoading(false);
      return;
    }

    document.title = `GOTaps`;

    const endpoint = isCardId
      ? `${API_BASE}/public/card/${encodeURIComponent(identifier)}`
      : `${API_BASE}/public/profile/${encodeURIComponent(identifier)}`;

    fetch(endpoint)
      .then(res => {
        if (!res.ok) throw new Error(res.status === 404 ? 'not-found' : 'error');
        return res.json();
      })
      .then(data => {
        if (data.redirect_to) {
          window.location.href = data.redirect_to;
          return;
        }
        setProfile(data.profile);
        setPlatforms(data.platforms || []);
        if (data.profile?.name) {
          document.title = `GOTaps - ${data.profile.name}`;
        }
        // Set favicon to profile photo or fallback to default
        const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        if (data.profile?.photo) {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = 64;
            canvas.height = 64;
            const ctx = canvas.getContext('2d');
            ctx.beginPath();
            ctx.arc(32, 32, 32, 0, Math.PI * 2);
            ctx.closePath();
            ctx.clip();
            ctx.drawImage(img, 0, 0, 64, 64);
            link.href = canvas.toDataURL('image/png');
            document.head.appendChild(link);
          };
          img.onerror = () => {
            link.href = process.env.PUBLIC_URL + '/favicon.png';
            document.head.appendChild(link);
          };
          img.src = data.profile.photo;
        } else {
          link.href = process.env.PUBLIC_URL + '/favicon.png';
          document.head.appendChild(link);
        }
      })
      .catch(e => setError(e.message === 'not-found' ? 'not-found' : 'error'))
      .finally(() => setLoading(false));
  }, [identifier, isCardId]);

  if (loading) return <LoadingScreen />;
  if (error) return <NotFound type={error} />;

  return (
    <ProfileView
      profile={profile}
      platforms={platforms}
      apiBase={API_BASE}
      backendUrl={BACKEND_URL}
      leadType={isCardId ? 1 : 2}
    />
  );
}

export default App;
